/**
 * Response envelope of POST /update_ipd_prescription_status/.
 *
 * A 200 "Success" can still decline rows: the envelope carries
 * updated_ids / noop_ids / rejected[], and each rejected entry has a
 * user-facing `reason` (backend can_transition writes sentences on purpose).
 * Callers must read rejected — the doctor console's habit of surfacing only
 * rejected[0] hid multi-row outcomes, so this helper reports all of them.
 *
 * Import-free so it stays unit-testable (axios ESM breaks Jest).
 */

export function statusUpdateOutcome(res) {
  const updated = Array.isArray(res?.updated_ids) ? res.updated_ids : [];
  const noop = Array.isArray(res?.noop_ids) ? res.noop_ids : [];
  const rejected = Array.isArray(res?.rejected) ? res.rejected : [];
  return {
    updated,
    noop,
    rejected,
    // A pure no-op is success too — the rows are already where the user asked;
    // treating it as an error (like MedicationOrdersPanel does) reads as failure.
    ok: updated.length > 0 || (noop.length > 0 && rejected.length === 0),
  };
}

/** One sentence listing every declined row's reason, or '' when none. */
export function rejectedReasonsText(rejected) {
  const rows = Array.isArray(rejected) ? rejected : [];
  if (!rows.length) return '';
  const reasons = rows.map((row) => {
    const reason = row?.reason || 'rejected';
    return row?.id != null ? `#${row.id}: ${reason}` : reason;
  });
  return `${rows.length} row(s) declined — ${reasons.join('; ')}`;
}
